import { render, staticRenderFns } from "./ticket-price-list.vue?vue&type=template&id=142013ea&scoped=true"
import script from "./ticket-price-list.vue?vue&type=script&lang=js"
export * from "./ticket-price-list.vue?vue&type=script&lang=js"
import style0 from "./ticket-price-list.vue?vue&type=style&index=0&id=142013ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142013ea",
  null
  
)

export default component.exports